import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';

import { Name as ItemName, Price as ItemPrice } from './Item';
import DefaultItemImage from '../components/ItemImage';

export const Grid = styled.div`
  margin: 0 auto;
  max-width: 1024px;
  display: grid;
  background-color: black;
  grid-gap: 1px;

  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const ItemImageWrapper = styled.div`
  background-color: white;
  padding: 32px;

  @media screen and (min-width: 768px) {
    padding: 64px;
  }
`;

export const ItemImage = ({ imageUrl }) => (
  <ItemImageWrapper>
    <DefaultItemImage imageUrl={imageUrl}></DefaultItemImage>
  </ItemImageWrapper>
);

export const ItemDetailsText = styled.div`
  background-color: white;
  padding: 32px;
  @media screen and (min-width: 768px) {
    padding: 64px;
  }
`;

export const Name = styled(ItemName)`
  text-align: initial;
  font-size: 36px;
`;

export const Price = styled(ItemPrice)`
  margin-top: 16px;
  text-align: initial;
  font-size: 24px;
`;

const StyledAddToCart = styled.button`
  margin-top: 32px;
  width: 110px;
  height: 44px;
  border: 0;
  border-radius: 0;
  background-color: #44db5e;
  color: white;
  text-transform: uppercase;
`;

export const AddToCart = () => {
  const [shouldRedirectToHome, setShouldRedirectToHome] = useState(false);
  return shouldRedirectToHome ? (
    <Redirect to="/" />
  ) : (
    <StyledAddToCart
      onClick={() => {
        setShouldRedirectToHome(true);
      }}
    >
      Add to cart
    </StyledAddToCart>
  );
};
